import LegalLayout, { Section } from "@/pages/LegalLayout";
import { BRAND } from "@/data/site";

export default function Support() {
  return (
    <LegalLayout eyebrow="Help" title="Support" updated="June 1, 2026">
      <p className="font-body text-lg text-zinc-300 leading-relaxed">
        Need a hand with ReBarOS? We're here to help — training questions,
        billing, account access, or anything else.
      </p>

      <Section heading="Contact us">
        <p>
          Email our team at{" "}
          <a href={`mailto:${BRAND.email}`} className="text-ember hover:underline" data-testid="support-email">
            {BRAND.email}
          </a>
          . We aim to respond within 1–2 business days.
        </p>
      </Section>

      <Section heading="In-app support">
        <p>
          The fastest help lives inside ReBarOS — the built-in AI Support can
          answer most questions instantly, right from the app.
        </p>
      </Section>

      <Section heading="Billing & subscriptions">
        <p>
          Subscriptions are managed through your app store (Google Play or the
          App Store). You can start your 3-day free trial, view renewals, or
          cancel anytime from your store account settings.
        </p>
      </Section>

      <Section heading="Privacy & data">
        <p>
          To request data export or account deletion, email{" "}
          <a href={`mailto:${BRAND.email}`} className="text-ember hover:underline">
            {BRAND.email}
          </a>{" "}
          and see our Privacy Policy for full detail.
        </p>
      </Section>
    </LegalLayout>
  );
}
